// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "EditableBroadcastForSaleProperty",
              "EditableBroadcastRentalProperty",
              "EditableQuietProperty"
            ]);
}

var fragmentConverter = {"__root":{"EditableQuietProperty":{"f":""},"EditableBroadcastRentalProperty":{"f":""},"EditableBroadcastForSaleProperty":{"f":""},"":{"u":"fragment"}}};

var fragmentConverterMap = {
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyAddressValidationDuplicatePropertyError_property",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DuplicateQuietPropertyError_quietProperty"
        }
      ],
      "type": "EditableQuietProperty",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty"
        }
      ],
      "type": "EditableBroadcastForSaleProperty",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty"
        }
      ],
      "type": "EditableBroadcastRentalProperty",
      "abstractKey": null
    }
  ],
  "type": "EditableProperty",
  "abstractKey": "__isEditableProperty"
};

var wrap_fragment = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
